import { EDlouheKratke } from 'enums/isin/udaje/dlouheKratke';

const dlouheKratkeSelect = [
    {
        value: EDlouheKratke.D,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_DK_D'
    },
    {
        value: EDlouheKratke.K,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_DK_K'
    },
    {
        value: EDlouheKratke.O,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_DK_O'
    }
];

export default dlouheKratkeSelect;
